import isInViewport from "../../../src/scripts/helpers/is-in-viewport";

export default class AnimatedIconList {
    static init() {
        Array.prototype.forEach.call(document.querySelectorAll('.animated-icon-list'), el => {
            new AnimatedIconList(el);
        });
    }

    constructor(element) {
        if (!element) return;
        this.element = element;

        window.addEventListener('scroll', (e)=> this.onScroll());
        this.onScroll();
    }

    onScroll() {
        let items = Array.from(this.element.querySelectorAll('.animated-icon-list__item:not(.active)'));
        let current = items.filter(el => isInViewport(el, { triggerLineFromTop: 0.7 }))

        current.forEach(el => {
            el.classList.add('active');
        });
    }
}
